<template>
  <div class="container-fluid what-we-do-page">
    <div class="upper-menu" v-if="this.isShowUpMenu">
      <img @click="goToStart"
           v-if="window.location.href.includes('projects') || window.location.href.includes('contactus')"
           class="menu-icon-left" src="/static/img/global/hippo_logo_purple.svg" alt="Menu">
      <img @click="seeOurProjects" v-else class="menu-icon-left" src="/static/img/global/hippo_logo_white.svg"
           alt="Menu">

      <img @click="goToMenu" class="menu-icon" src="/static/img/menu.svg" alt="Menu"
           v-if="!window.location.href.includes('site-menu') && !window.location.href.includes('projects')">
      <img @click="goToMenu" class="menu-icon" src="/static/img/menu-copy-2.svg" alt="Menu"
           v-if="window.location.href.includes('projects') || window.location.href.includes('contactus')">
      <img v-if="window.location.href.includes('cover') && !this.isMobile" class="menu-project-right"
           @click="seeOurProjects" src="/static/img/menu-project-2.png" alt="Projects">
    </div>
    <div class="banner">

      <img class="bg" src="/static/img/banners/adult-agency-business.jpg"
           srcset="/static/img/banners/adult-agency-business.jpg" alt="Hippotec">

      <div class="container logo" v-bind:style="{'left':this.mobileSite.titleLeft, 'right':this.mobileSite.titleLeft}">
        <div class="row">
          <div class="col-xl-12 col-md-12 col-sm-12 ">
            <div class="title-image" v-bind:style="{'font-size': this.mobileSite.titleSize}">DESIGN &</div>
            <div class="title-image" v-bind:style="{'font-size': this.mobileSite.titleSize}">DEVELOPMENT</div>
            <div class="title-image" v-bind:style="{'font-size': this.mobileSite.titleSize}">YOUR IDEAS</div>
            <img class="curved-line" src="../../static/img/global/pink-line.svg">
          </div>
          <div class="col-xl-12 col-md-12 col-sm-12 row-col">
            <div class="title-image-small"
                 v-bind:style="{'width' : this.mobileSite.title2Width, 'margin-right': this.mobileSite.marginRight}">
              Hippotec are a high-end "mobile first" development studio, specialized in UI/UX, iOS, android & web
              environments
            </div>
          </div>
        </div>
        <button @click="seeOurProjects" class="submit-button" type="submit">VIEW OUR WORK</button>
      </div>
      <div class="overlay"></div>
    </div>

    <section class="what-we-do">
      <div class="container">
        <div class="row">
          <div class="col-sm-12 col-md-12 mt-5 pt-5">

            <div class="what-we-do-title" v-bind:style="{'margin-left': this.mobileSite.textLeft}">
              <span class="what-we-do-titletext">WHAT WE DO</span>
            </div>

            <p class="what-we-do-desc"
               v-bind:style="{'margin-left': this.mobileSite.textLeft, 'margin-right': this.mobileSite.marginRight}">
              We customize your precise objectives and needs, based on transparency,
              collaboration and respect. After discussing your goals, business opportunities
              and the work you&apos;ve already done, we&apos;ll identify where and how can we help.
              <br><span>Our most common contributions include:</span>
            </p>

          </div>

          <div class="col-md-12 what-we-do-features" v-bind:style="{'margin-left': this.mobileSite.textLeft}">

            <div>
              <div class="letter-title">
                <img class="letter-title-letter" src="/static/img/letters/r-copy.png" alt="Research">
                <div class="letter-title-text">RESEARCH</div>
              </div>
              <div v-if="!this.isMobile" class="tab">
                <div class="left">
                  <img class="what-we-do-image" src="/static/img/WhatWeDo/illustration1.svg" alt="Research">
                </div>
                <!--                <div v-else class="mobile-image">
                                  <img class="what-we-do-image" src="/static/img/illustration-1.png" alt="Research">
                                </div>-->
                <div class="right">

                  Before jumping to conclusions and solutions we start<br/>
                  from scratch - research. The starting point of every idea<br/>
                  is an extensive research of the target market and<br/>
                  competition. Learning the field and identifying the relevant<br/>
                  personas will help us build a strategy suting best your <br/>
                  business and your clients. The research conducted will<br/>
                  ensure we deliver an innovative product tailored fit for<br/>
                  your users.
                </div>
              </div>
              <div v-else class="mobile-tab">
                <img class="mobile-image" src="/static/img/WhatWeDo/illustration1.svg" alt="Research">
                <!--                <div v-else class="mobile-image">
                                  <img class="what-we-do-image" src="/static/img/illustration-1.png" alt="Research">
                                </div>-->
                <div class="right">

                  Before jumping to conclusions and solutions we start
                  from scratch - research. The starting point of every idea
                  is an extensive research of the target market and
                  competition. Learning the field and identifying the relevant
                  personas will help us build a strategy suting best your
                  business and your clients. The research conducted will
                  ensure we deliver an innovative product tailored fit for
                  your users.
                </div>
              </div>
            </div>
            <div class="letter-title">
              <img class="letter-title-letter" src="/static/img/letters/u.png" alt="Research">
              <div class="letter-title-text">UX</div>
            </div>
            <div v-if="!this.isMobile" class="tab">
              <div class="left">
                <img class="what-we-do-image" src="/static/img/WhatWeDo/illustration-2.svg" alt="Research">
              </div>
              <div class="right">

                A good user experience is built out of many factors:<br/>
                an easy-to-understand interface, an intuitive flow – but<br/>
                equally important – an innovative experience that gets<br/>
                the user excited and engaged. Our UX team will find that<br/>
                extra factor that is suited for your target audience to<br/>
                make your product unique and unforgettable.
              </div>
            </div>
            <div v-else class="mobile-tab">
              <img class="mobile-image" src="/static/img/WhatWeDo/illustration-2.svg" alt="Research">
              <div class="right">

                A good user experience is built out of many factors:
                an easy-to-understand interface, an intuitive flow – but
                equally important – an innovative experience that gets
                the user excited and engaged. Our UX team will find that
                extra factor that is suited for your target audience to
                make your product unique and unforgettable.
              </div>
            </div>

            <div class="letter-title">
              <img class="letter-title-letter" src="/static/img/letters/u.png" alt="Research">
              <div class="letter-title-text">UI</div>
            </div>
            <div v-if="!this.isMobile" class="tab">
              <div class="left">
                <img class="what-we-do-image" src="/static/img/WhatWeDo/illustration-3.svg" alt="Research">
              </div>
              <div class="right">
                People judge a product by its cover – that’s why we<br/>
                believe that the great user experience we create has to<br/>
                be followed by an even greater design. We will bring the<br/>
                wireframes to life and turn them into a beautiful,<br/>
                polished product. We will create several design concepts<br/>
                perfectly fit for your goals, your users needs and define<br/>
                design guidelines.
              </div>
            </div>
            <div v-else class="mobile-tab">
              <img class="mobile-image" src="/static/img/WhatWeDo/illustration-3.svg" alt="Research">
              <div class="right">
                People judge a product by its cover – that’s why we
                believe that the great user experience we create has to
                be followed by an even greater design. We will bring the
                wireframes to life and turn them into a beautiful,
                polished product. We will create several design concepts
                perfectly fit for your goals, your users needs and define
                design guidelines.
              </div>
            </div>

            <div class="letter-title">
              <img class="letter-title-letter" src="/static/img/letters/d.png" alt="Research">
              <div class="letter-title-text">DEVELOP</div>
            </div>
            <div v-if="!this.isMobile" class="tab">
              <div class="left develop">
                <img class="what-we-do-image" src="/static/img/WhatWeDo/illustration-4.svg" alt="Research">
              </div>
              <div class="right">
                Weather you need a native iOS or Android app, mobile<br/>
                website or a front end solution, admin panel or server (or<br/>
                a full end to end solution – “all included”), our team of<br/>
                experienced and professional developers will deliver a<br/>
                state of the art product, using the most advanced and<br/>
                suitable techniques for every requirement. We offer<br/>
                flexible services either as a dedicated team built<br/>
                especially for your needs or by using our “commando”<br/>
                team of experts on demand.
              </div>
            </div>
            <div v-else class="mobile-tab">
              <img class="mobile-image" src="/static/img/WhatWeDo/illustration-4.svg" alt="Research">
              <div class="right">
                Weather you need a native iOS or Android app, mobile
                website or a front end solution, admin panel or server (or
                a full end to end solution – “all included”), our team of
                experienced and professional developers will deliver a
                state of the art product, using the most advanced and
                suitable techniques for every requirement. We offer
                flexible services either as a dedicated team built
                especially for your needs or by using our “commando”
                team of experts on demand.
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>

    <div class="banner">

      <img class="bg" src="/static/img/middlepic.png" srcset="/static/img/middlepic.png" alt="Hippotec">

      <div class="container logo" v-bind:style="{'left':this.mobileSite.titleLeft}">
        <div class="row">
          <div class="col-xl-12 col-md-12 col-sm-12 row-col">
            <div class="title-second-image" v-bind:style="{'width':this.mobileSite.banner2Width}">We build outstanding
              and compelling interface design to help you achieve your, business goals and make your customers happy.
            </div>
          </div>
          <img class="curved-line" src="../../static/img/global/pink-line.svg">
        </div>
      </div>
      <div class="overlay"></div>
    </div>

    <section>
      <div class="container">
        <div class="row">
          <div class="col-sm-12 col-md-12">

            <div class="small-title">
              SOME FACTS ABOUT HIPPOTEC
            </div>
            <div class="some-facts-about-hippotec">
              <div>
                <div class="some-facts-about-hippotec-large-title">10</div>
                <p>
                  Established<br/>
                  10 years ago
                </p>
              </div>
              <img class="some-facts-about-hippotec-image" src="/static/img/group-15.svg" alt="">
              <div>
                <div class="some-facts-about-hippotec-large-title">50</div>
                <p>
                  Clients worked<br/>
                  with us so far
                </p>
              </div>
              <img class="some-facts-about-hippotec-image" src="/static/img/group-15.svg" alt="">
              <div>
                <div class="some-facts-about-hippotec-large-title">376</div>
                <p>
                  Kg of cookies were<br/>
                  ingested during meetings
                </p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>

    <section>
      <div class="container">
        <div class="row">
          <div class="col-sm-12 col-md-12">

            <div class="small-title">
              <span>ADDITIONAL SERVICES WE CAN OFFER YOU</span>
            </div>

            <div class="additional-services-we-can-offer-you"
                 v-bind:style="{'display': this.mobileSite.additionalServicesInline}">
              <div class="left" v-bind:style="{'width' : this.mobileSite.additionalServicesInlineWidth}">
                - Rapid proof of concept prototypes (poc)<br/>
                - User interface redesigns<br/>
                - User testing and surveys<br/>
                - Dashboards, UI &amp; data visualization<br/>
                - Heuristic reviews of your websites
              </div>
              <div class="right" v-bind:style="{'width' : this.mobileSite.additionalServicesInlineWidth}">
                - Unique custom icon sets and logo<br/>
                - Micro interactions (simple animated UI)<br/>
                - Specification document<br/>
                - Code review<br/>
                - QA
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>


    <ContactUs>

    </ContactUs>
  </div>
</template>

<script>
  import SomeFacts from '../../static/img/combinedShape.png'
  //import ContactUs from './../components/ContactUs'

  import ContactUs from '@bit/hippotec.website2019.contact-us';

  export default {
    name: 'WhatWeDo',
    data() {
      return {
        SomeFacts: SomeFacts,
        ContactUs: ContactUs,
        isShowUpMenu: false,
        upperMenuTopLast: 0,
        window,
        isMobile: false,
        mobileSite: {
          titleSize: "60px",
          titleLeft: "50%",
          title2Width: "50%",
          textLeft: "0px",
          banner2Width: "100%",
          additionalServicesInline: "flex",
          additionalServicesInlineWidth: "50%",
          marginRight: "0px"
        }
      }
    },
    methods: {
      goToMenu: function () {
        this.$router.push('/site-menu');
      },
      goToStart: function () {
        this.$router.push('/what-we-do');
      },
      seeOurProjects: function () {
        this.$router.push('projects')
      },
      prepareMobile(isMobile) {
        this.isMobile = isMobile;
        if (isMobile) {
          this.mobileSite.titleSize = "35px";
          this.mobileSite.titleLeft = "35%";
          this.mobileSite.title2Width = "160%";
          this.mobileSite.textLeft = "20px";
          this.mobileSite.banner2Width = "160%";
          this.mobileSite.additionalServicesInline = "block"
          this.mobileSite.additionalServicesInlineWidth = "100%";
          this.mobileSite.marginRight = "20px"
        }
      },
      checkScroll() {
        var $win = $(window);
        if ($win.scrollTop() > 200) {
          if (this.upperMenuTopLast > $win.scrollTop()) {
            this.isShowUpMenu = true;
          } else {
            this.isShowUpMenu = false;
          }
          this.upperMenuTopLast = $win.scrollTop()
        } else {
          this.isShowUpMenu = false;
        }
      }
    },
    components: {
      ContactUs: ContactUs
    },
    created: function () {
      //this.prepareMobile(localStorage.isMobile == 'true');
      this.prepareMobile(localStorage.isMobile == 'true');
    },
    mounted() {
      var $win = $(window);
      $win.scroll(this.checkScroll);
    }
  }
</script>

<style lang="scss" scoped>
  @import "../assets/scss/what-we-do";

  .upper-menu {
    position: fixed;
    opacity: 0.7;
    width: 100%;
    height: 110px;
    background-color: #000000;
    top: 0;
    left: 0;
    z-index: 2000;
  }
  .menu-icon-left {
    opacity: 1;
    position: absolute;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    float: left;
    cursor: pointer;
    left: 56px
  }
  .menu-icon {
    opacity: 1;
    position: absolute;
    float: right;
    width: 52px;
    height: 52px;
    cursor: pointer;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    right: 56px;
    animation: menuclose-icon-right 1s forwards 1s;
  }
  .what-we-do-title {
    margin-bottom: 20px;
  }

  .additional-services-we-can-offer-you {
    width: 100%;
    text-align: left;
    align-items: center;
    margin-top: 20px;
    margin-bottom: 50px;

    .left,
    .right {
      font-size: 18px;
      font-weight: 300;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.67;
      letter-spacing: normal;
      color: var(--black);
      text-align: left;
    }

  }

  .title-image {
    text-align: left;
    font-family: Rubik, sans-serif;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.1;
    letter-spacing: normal;
    color: #ff9efd;
  }

  .logo {
    position: absolute;
    top: 50%;
    width: 60%;
    max-width: 100%;
    text-align: center;
    transform: translate(-50%, -50%);
    z-index: 1;

    img {
      zoom: 1.2;
      width: 174px;
      height: 98px;
      object-fit: cover;
      object-position: center;
      margin-bottom: 20px;
    }

    p {
      width: 969px;
      max-width: 100%;
      margin: auto;
      color: #fff;
      font-size: 33px;
      font-weight: 300;
      text-align: center;
    }
  }

  .title-image-small {
    margin-left: 10px;
    font-family: Rubik, sans-serif;
    font-size: 18px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.39;
    letter-spacing: normal;
    color: var(--white);
  }

  .mobile-tab {
    flex-direction: row;
    align-items: start;
    position: relative;
    margin-bottom: 50px;

    .mobile-image {
      margin-top: 25px;
      margin-bottom: 25px;
    }

    .right {
      font-size: 18px;
      margin-right: 20px;
    }
  }

  .title-second-image {
    text-align: left;
    font-family: Rubik, sans-serif;
    font-size: 24px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.58;
    letter-spacing: normal;
    color: #ff9efd;
  }
</style>



// WEBPACK FOOTER //
// src/pages/WhatWeDo.vue